import React, { Component } from 'react';

export default class RadioField extends Component {
    handleChange = (e) => {
        this.props.onChange(this.props.fieldDef.fieldId, e.target.value);
    };

    render() {
        const { fieldDef, value, hasError, errorMessage, disabled } = this.props;
        const options = fieldDef.options || [];
        const isRequired = fieldDef.validation && fieldDef.validation.required;

        return (
            <div className="form-group">
                <label>
                    {fieldDef.label}
                    {isRequired && <span className="text-danger"> *</span>}
                </label>
                <div>
                    {options.map((opt) => (
                        <div key={opt.value} className="form-check form-check-inline">
                            <input
                                className="form-check-input"
                                type="radio"
                                name={fieldDef.fieldId}
                                id={fieldDef.fieldId + '_' + opt.value}
                                value={opt.value}
                                checked={value === opt.value}
                                onChange={this.handleChange}
                                disabled={disabled}
                            />
                            <label className="form-check-label" htmlFor={fieldDef.fieldId + '_' + opt.value}>
                                {opt.label}
                            </label>
                        </div>
                    ))}
                </div>
                <div className={hasError ? 'inline-errormsg' : 'hidden'}>
                    <i className="fa fa-exclamation-circle" aria-hidden="true">
                        &nbsp;{errorMessage || 'This field is required.'}
                    </i>
                </div>
            </div>
        );
    }
}
